import { type Editor } from '@tiptap/react';
import { useEffect } from 'react';

import { isEditorLive } from '../core';

/**
 * Syncs editor editable state when the editable prop changes.
 *
 * @param editor - The Tiptap editor instance
 * @param editable - Whether the editor should be editable
 */
export const useEditorEditableSync = (
  editor: Editor | null | undefined,
  editable: boolean
) => {
  useEffect(() => {
    if (!isEditorLive(editor, 'useEditorEditableSync')) {
      return;
    }
    // false is for emitOnUpdate, default is true
    editor.setEditable(editable, false);
    // setEditable emits no transaction, and useEditorState only reruns on one.
    // The doc is unchanged, so this does not emit `update` or enter history.
    // A stub or not-yet-mounted editor has no view to dispatch through.
    const transaction = editor.state?.tr?.setMeta('addToHistory', false);
    if (transaction) {
      editor.view?.dispatch(transaction);
    }
  }, [editable, editor]);
};
